import api from "../api";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    products: [],
    selectedProducts: [],
    productsCount: null,
    productsSearchCount: null,
    productsWithVideoCount: null,
    productUniqueValues: null,
    loadingFullList: true,
    hasLargeAmountOfProducts: null,
  },
  getters: {
    getProductById: (state) => (id) => {
      return state.products.find((product) => product._id === id);
    },
    getProductUniqueValues: (state) => {
      return state.productUniqueValues;
    },
  },
  mutations: {
    setProducts(state, products) {
      state.products = products;
    },
    setProductsCount(state, count) {
      state.productsCount = count;
      state.hasLargeAmountOfProducts = count > 500;
    },
    setProductsSearchCount(state, count) {
      state.productsSearchCount = count;
    },
    setProductsWithVideoCount(state, count) {
      state.productsWithVideoCount = count;
    },
    setProductUniqueValues(state, productUniqueValues) {
      state.productUniqueValues = productUniqueValues;
    },
    setSelectedProducts(state, products) {
      state.selectedProducts = products;
    },
    updateProduct(state, product) {
      const indexOfProduct = state.products.findIndex(
        (item) => item._id === product._id
      );

      Vue.set(state.products, indexOfProduct, product);
    },
    deleteProduct(state, productId) {
      state.products.splice(
        state.products.findIndex((item) => item._id === productId),
        1
      );
    },
    createProduct(state, productCreated) {
      state.products.push(productCreated);
    },
    resetSelectedProducts(state) {
      state.selectedProducts = [];
    },
    resetState(state) {
      state.products = [];
      state.selectedProducts = [];
      state.productsCount = null;
      state.productsSearchCount = null;
      state.productsWithVideoCount = null;
      state.productUniqueValues = null;
      state.loadingFullList = true;
      state.hasLargeAmountOfProducts = null;
    },
  },
  actions: {
    async getProductsCount({ commit, state }, siteId) {
      if (Number.isInteger(state.productsCount)) {
        return state.productsCount;
      }

      const productsCount = await api.getProductsCount(siteId);
      commit("setProductsCount", productsCount.count);
      return productsCount.count;
    },
    async getProductsWithVideoCount({ commit, state }, siteId) {
      if (Number.isInteger(state.productsWithVideoCount)) {
        return state.productsWithVideoCount;
      }

      const productsWithVideoCount = await api.getProductsWithVideoCount(
        siteId
      );
      commit("setProductsWithVideoCount", productsWithVideoCount.count);
      return productsWithVideoCount.count;
    },
    async getProducts(
      { commit, state },
      { siteId, isProductListView, query, initialCall }
    ) {
      try {
        if (
          !isProductListView &&
          !state.hasLargeAmountOfProducts &&
          state.products.length
        ) {
          return state.products;
        }

        if (!isProductListView && initialCall && state.products.length > 50) {
          return state.products;
        }

        const data = await api.getProductsAddToCart(
          siteId,
          isProductListView,
          query
        );

        commit("setProducts", data.products);
        commit("setProductsSearchCount", data.productsCount);
        return data.products;
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },
    async getSpecificProducts(
      { state, commit },
      { siteId, query, isProductListView }
    ) {
      try {
        let products = [];

        if (!query.ids?.length && !query.productIds?.length) return products;

        //If the full product list was already loaded only filter the current products state
        if (
          state.hasLargeAmountOfProducts !== null &&
          !state.hasLargeAmountOfProducts
        ) {
          products = state.products.filter((product) => {
            if (query.ids) return query.ids.includes(product._id);
            else if (query.productIds)
              return query.productIds.includes(product.productId);
          });
        } else {
          const data = await api.getProductsAddToCart(
            siteId,
            isProductListView,
            query
          );

          products = data.products;
        }

        commit("setSelectedProducts", products);
      } catch (error) {
        console.error("Error fetching specific products:", error);
      }
    },
    async createProduct({ commit }, productData) {
      try {
        const productCreated = await api.createProduct(productData);
        // Fetch the updated list of products after creating a new product
        commit("createProduct", productCreated);
      } catch (error) {
        console.error("Error creating product:", error);
      }
    },
    async deleteProduct({ commit }, { productId }) {
      try {
        await api.deleteProduct(productId);
        commit("deleteProduct", productId);
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    },
    async updateProduct({ commit }, { productId, productData }) {
      try {
        const product = await api.updateProduct(productId, productData);

        commit("updateProduct", product);
      } catch (error) {
        console.error("Error updating product:", error);
      }
    },
    async forceSyncProducts({ commit }, siteId) {
      try {
        const products = await api.forceSyncProducts(siteId);
        commit("setProducts", products);
        return products;
      } catch (error) {
        console.error("Error forcing product sync:", error);
        throw error;
      }
    },
    //Get the list of brands and category
    async getProductUniqueValues({ commit, state }, siteId) {
      try {
        if (state.productUniqueValues) {
          return state.productUniqueValues;
        }

        const productUniqueValues = await api.getProductUniqueValues(siteId);
        commit("setProductUniqueValues", productUniqueValues);
      } catch (error) {
        console.error("Error getProductUniqueValues:", error);
        throw error;
      }
    },
  },
};
